module.exports = __webpack_public_path__ + "img/icon_d.89346d6a.png";